<template>
  <v-container>
    <ContentHeader
      header-icon="mdi-link-box-outline"
      header-title="Signup Code Search"
      back-navigation
      back-navigation-href="/admin"
      back-navigation-text="To Old Admin"
    >
    </ContentHeader>
    <PtSheet>
      <v-sheet max-width="350" class="d-flex">
        <v-form ref="form" @submit.prevent>
          <v-text-field
            label="Signup Code"
            dense
            outlined
            v-model="code"
            class="mr-4"
            :rules="[v => !!v || 'Enter a Signup Code']"
            validate-on-blur
            @blur="() => $refs.form.resetValidation()"
          ></v-text-field>
        </v-form>
        <v-btn
          type="submit"
          color="primary"
          @click="searchSignupCode()"
          class="mr-2"
        >
          Search
        </v-btn>
        <v-btn text @click="reset(false)">Reset</v-btn>
      </v-sheet>
      <div v-if="covg">
        <v-card flat :class="['covg-name', { alert: covg.trashed }]">
          <v-card-title class="d-flex flex-wrap">
            <div class="headline">{{ getBusinessName() }}</div>
            <v-spacer />
            <div class="subtitle-2 text-right mr-4 colorNeutralsNavy400--text">
              COVG ID: {{ covg.id }}
            </div>
          </v-card-title>
          <v-card-text
            v-if="Array.isArray(covg.extraNames) && covg.extraNames.length"
          >
            <span>{{ covg.extraNames.join() }}</span>
          </v-card-text>
        </v-card>
      </div>
      <div class="d-flex">
        <SignupCodeCard
          v-if="signupCode"
          :signup-code="signupCode"
        ></SignupCodeCard>
      </div>
      <div v-if="Array.isArray(extraSignupCodes) && extraSignupCodes.length">
        <v-divider class="my-4"></v-divider>
        <div class="subtitle-1 ml-4">
          Other signup codes for the same vendor group:
        </div>
        <div class="d-flex flex-wrap">
          <SignupCodeCard
            v-for="extraCode in extraSignupCodes"
            :signup-code="extraCode"
            :key="extraCode.code"
          >
          </SignupCodeCard>
        </div>
      </div>
    </PtSheet>
  </v-container>
</template>

<script>
import { get } from "@/services/request";
import { signupCodeAPI, allSignupCodeAPI, covgByIdAPI } from "@/services/api";
import PtSheet from "@/components/PtSheet.vue";
import SignupCodeCard from "@/views/admin/SignupCodeCard.vue";
import hasNotifications from "@/mixins/has-notifications";
import ContentHeader from "@/views/ContentHeader.vue";

export default {
  name: "SignupCodeSearch",
  components: { ContentHeader, SignupCodeCard, PtSheet },
  mixins: [hasNotifications],
  data() {
    return {
      code: null,
      signupCode: null,
      extraSignupCodes: null,
      covg: null
    };
  },
  methods: {
    searchSignupCode() {
      this.reset(true);

      let valid = this.$refs.form.validate();
      if (!valid) return;

      get(signupCodeAPI.getUrl(this.code))
        .then(response => {
          if (response && response.data) {
            this.signupCode = response.data;
            get(covgByIdAPI.getUrl({ covgId: this.signupCode.covgId }))
              .then(response => {
                if (response && response.data) {
                  this.covg = response.data;
                }
              })
              .catch(error => {
                this.showMessage({
                  text: "Error getting business names.",
                  mode: "error"
                });
                console.error("Error getting business names", error);
              });
            get(allSignupCodeAPI.getUrl({ covgId: this.signupCode.covgId }))
              .then(response => {
                if (response && response.data) {
                  this.extraSignupCodes = response.data.filter(
                    sc => sc.code !== this.code
                  );
                }
              })
              .catch(error => {
                this.showMessage({
                  text: "Error getting other signup codes.",
                  mode: "error"
                });
                console.error("Error getting other signup codes", error);
              });
          }
        })
        .catch(error => {
          this.showMessage({
            text: "Signup code not found.",
            mode: "warning"
          });
          console.warn("Signup code not found", error);
        });
    },
    reset(partial) {
      if (!partial) {
        this.code = null;
        this.$refs.form.reset();
      }
      this.signupCode = null;
      this.extraSignupCodes = null;
      this.covg = null;
    },
    getBusinessName() {
      let name = this.covg.preferredName;
      if (this.covg.trashed) name += " - Trashed";
      return name;
    }
  }
};
</script>

<style lang="scss" scoped>
.covg-name.alert {
  background-color: $color-semantic-state-red-200;
  color: $color-semantic-state-red-800;
}
</style>
